import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
}

function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function useSEO({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}